/** Rótulo de identidade do contato (telefone, @username ou BSUID). */
export const getContactIdentifierLabel = (contact) => {
  if (!contact) return "";
  if (contact.phoneNumber) return contact.phoneNumber;
  if (contact.username) {
    const u = String(contact.username).replace(/^@/, "");
    return `@${u}`;
  }
  if (contact.bsuid) return contact.bsuid;
  if (contact.number && /^[A-Z]{2}\.[A-Za-z0-9]+$/.test(contact.number)) {
    return "WhatsApp (telefone não compartilhado)";
  }
  return contact.number || "";
};

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

const phoneVariants = (digits) => {
  const d = digitsOnly(digits);
  if (!d) return [];
  const set = new Set([d]);
  if (d.length >= 12) set.add(d.slice(-11));
  if (d.length >= 13) set.add(d.slice(2));
  return [...set];
};

const namesMatchPhone = (name, contact) => {
  const incomingDigits = digitsOnly(name);
  if (incomingDigits.length < 10) return false;
  const variants = [
    ...phoneVariants(contact?.phoneNumber),
    ...phoneVariants(contact?.number),
  ];
  return variants.some(
    (v) =>
      v === incomingDigits ||
      v.endsWith(incomingDigits) ||
      incomingDigits.endsWith(v)
  ) || /^\d+$/.test(String(name).replace(/\s/g, ""));
};

/** Evita socket/UI sobrescrever nome editado manualmente com telefone do webhook. */
export const mergeContactPreservingManualName = (prev, incoming) => {
  if (!incoming) return prev;
  if (!prev || prev.id !== incoming.id) return incoming;

  const incomingName = incoming.name || "";
  const prevName = (prev.name || "").trim();
  const looksLikePhone = namesMatchPhone(incomingName, incoming);

  if (looksLikePhone && prevName && prevName !== incomingName) {
    return { ...incoming, name: prevName };
  }

  return { ...prev, ...incoming };
};

export const hasCallablePhone = (contact) =>
  Boolean(contact?.phoneNumber || (contact?.number && !/^[A-Z]{2}\./.test(contact.number)));
